// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var FormalityCompat__PublicHelpers = require("./FormalityCompat__PublicHelpers.bs.js");
var FormalityCompat__FormAsyncOnChangeWithId = require("./FormalityCompat__FormAsyncOnChangeWithId.bs.js");

var Async = {
  Make: undefined,
  MakeWithId: undefined,
  MakeOnBlur: undefined,
  MakeOnBlurWithId: undefined,
  debounceInterval: FormalityCompat__FormAsyncOnChangeWithId.defaultDebounceInterval
};

var Dom = FormalityCompat__PublicHelpers.Dom;

var Strategy;

var FormStatus;

var Make;

var MakeWithId;

exports.Dom = Dom;
exports.Strategy = Strategy;
exports.FormStatus = FormStatus;
exports.Make = Make;
exports.MakeWithId = MakeWithId;
exports.Async = Async;
/* FormalityCompat__FormAsyncOnChangeWithId Not a pure module */
